import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";

const IMAGE_SIZE = 35;

const style = () => {
  const { borderRadius2, borderWidth1, colorBgBase, colorBorderInput, colorTextMedium, space2, space4 } = theme();

  return StyleSheet.create({
    content: {
      flexDirection: "row",
    },
    image: {
      borderRadius: borderRadius2,
      width: IMAGE_SIZE,
    },
    info: {
      flex: 1,
      marginLeft: space2,
    },
    mobileWrapper: {
      borderBottomWidth: borderWidth1,
      borderColor: colorBorderInput,
    },
    price: {
      justifyContent: "flex-end",
    },
    row: {
      flex: 1,
      justifyContent: "center",
    },
    text: {
      color: colorTextMedium,
    },
    wrapper: {
      backgroundColor: colorBgBase,
      flexDirection: "row",
      paddingVertical: space4,
    },
  });
};

export { style, IMAGE_SIZE };
